<template>
    <div style="min-width: 300px">
        <ForgotPassword
            v-if="actualView === 'forgotPassword'"
            :showCloseIcon="showCloseIcon"
            :onCloseclick="onCloseclick"
            :openLogin="openLogin" />
        <Login
            v-else
            :showCloseIcon="showCloseIcon"
            :onCloseclick="onCloseclick"
            :openForgotPassword="openForgotPassword" />
    </div>
</template>

<script>
import Login from './Login';
import ForgotPassword from './ForgotPassword';

export default {
    props: {
        onCloseclick: {
            type: Function,
            required: false
        },
        showCloseIcon: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Login,
        ForgotPassword
    },
    data() {
        return {
            actualView: 'login',
            views: ['login', 'forgotPassword']
        }
    },
    methods: {
        openForgotPassword() {
            this.actualView = 'forgotPassword';
        },
        openLogin() {
            this.actualView = 'login';
        }
    }
}
</script>
